"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";
import { HiSearch, HiHome } from "react-icons/hi";
import ErrorLayout from "@/components/layout/ErrorLayout";
import { LanguageProvider } from "@/lib/i18n/context";
import "@/app/globals.css";
import { Cinzel, Great_Vibes, Lato } from "next/font/google";
import CustomCursor from "@/components/ui/CustomCursor";

// Re-define fonts for the standalone 404 page
const cinzel = Cinzel({
  subsets: ["latin"],
  variable: "--font-serif",
  display: "swap",
});

const greatVibes = Great_Vibes({
  subsets: ["latin"],
  weight: "400",
  variable: "--font-script",
  display: "swap",
});

const lato = Lato({
  subsets: ["latin", "latin-ext"],
  weight: ["100", "300", "400", "700", "900"],
  variable: "--font-sans",
  display: "swap",
});

// Root Not Found - Handles 404s that don't match the [lang] route
// MUST contain html and body tags because it replaces the root layout
export default function RootNotFound() {
  const content = {
    tagline: "Error 404",
    title: "Page Not Found",
    description: "The page you are looking for does not exist or has been moved.",
    backHome: "Back to Home",
  };

  return (
    <html lang="en">
      <body className={`${cinzel.variable} ${greatVibes.variable} ${lato.variable} font-sans antialiased bg-brand-charcoal text-white`}>
        <LanguageProvider defaultLanguage="en">
          <ErrorLayout
            icon={HiSearch}
            tagline={content.tagline}
            title={content.title}
            description={content.description}
            actions={
              <Link href="/">
                <Button className="w-full md:w-auto bg-white text-brand-charcoal hover:bg-brand-gold hover:text-white px-8 py-6 rounded-none uppercase text-xs font-bold tracking-[0.2em] transition-all">
                  <HiHome size={16} className="mr-2" /> {content.backHome}
                </Button>
              </Link>
            }
          />
        </LanguageProvider>
        <CustomCursor />
      </body>
    </html>
  );
}
